import { redirect, type LoaderFunctionArgs } from 'react-router-dom'
import { matterPaths } from '@/routing/paths'
import type { RouteFactory } from '../../types'

/**
 * Keeps old Matter Files bookmarks working by redirecting them to the current User Files root.
 */
export const createFilesChildRoutes: RouteFactory = () => [
  {
    path: 'files/:driveName/*',
    loader: ({ params }: LoaderFunctionArgs) => redirect(params.matterId ? matterPaths.userFiles.root(params.matterId) : '/dashboard/matters'),
  },
]
